<template>
   <div class="AuditDocuments">
      <div class="titlePage">
         Consulta de Auditoría de Documentos Iceberg
      </div>
      <div class="selectDocument">
         <label>Seleccione el documento</label>
         <select v-model="typeDocument">
            <option value="" disabled>Seleccione...</option>
            <option
               v-for="doc in documentOptions"
               :key="doc.value"
               :value="doc.value"
               >
               {{ doc.label }}
            </option>
         </select>
      </div>
      <!-- FORMULARIO DINÁMICO -->
      <component
         v-if="currentFormComponent"
         :is="currentFormComponent"
         @showResultOrder="showResultOrder"
         />
      <!-- TABLA RESULTADO -->
      <TablaOrden
         v-if="orderDataObject.length"
         :OrderDataObject="orderDataObject"
         />
   </div>
</template>
<script>
import FormularioLiquidacionOrden from '@/components/Ordenes/FormularioOrden.vue'
import FormularioConceptoNota from '@/components/Ordenes/FormularioConceptoNota.vue'
import FormularioCredito from '@/components/Ordenes/FormularioCredito.vue'
import FormularioNotaDebito from '@/components/Ordenes/FormularioNotaDebito.vue'
import FormularioNotaCredito from '@/components/Ordenes/FormularioNotaCredito.vue'
import FormularioOrden from '@/components/Ordenes/FormularioOrdenDos.vue'
import FormularioReciboConsignacion from '@/components/Ordenes/FormularioReciboConsignacion.vue'
import FormularioSolicitudNota from '@/components/Ordenes/FormularioSolicitudNota.vue'
import TablaOrden from '@/components/Ordenes/TablaOrden.vue'

export default {

  components:{
    FormularioLiquidacionOrden,
    FormularioConceptoNota,
    FormularioCredito,
    FormularioNotaDebito,
    FormularioNotaCredito,
    FormularioOrden,
    FormularioReciboConsignacion,
    FormularioSolicitudNota,
    TablaOrden
  },

  data(){
    return{

      orderDataObject: [],

      typeDocument:null,

      documentOptions:[
        {value:'concepto-nota', label:'Concepto nota'},
        {value:'credito', label:'Crédito'},
        {value:'liquidacion_orden', label:'Liquidación orden'},
        {value:'nota_debito', label:'Nota débito'},
        {value:'nota_credito', label:'Nota crédito'},
        {value:'orden', label:'Orden'},
        {value:'recibo_consignacion', label:'Recibo consignación'},
        {value:'solicitud_nota', label:'Solicitud nota'}
      ]

    }
  },

  computed:{

    currentFormComponent(){

      const forms = {

        'liquidacion_orden': 'FormularioLiquidacionOrden',
        'concepto-nota': 'FormularioConceptoNota',
        'credito': 'FormularioCredito',
        'nota_debito': 'FormularioNotaDebito',
        'nota_credito': 'FormularioNotaCredito',
        'orden': 'FormularioOrden',
        'recibo_consignacion': 'FormularioReciboConsignacion',
        'solicitud_nota': 'FormularioSolicitudNota'

      }

      return forms[this.typeDocument] || null
    }

  },

  watch:{
    typeDocument(){
      this.orderDataObject=[]
    }
  },

  methods:{

    showResultOrder(orderData){
      this.orderDataObject = orderData
    }

  }

}
</script>